<script>
	
	import Router, {location, link} from 'svelte-spa-router';
	import Home from './views/Home.svelte';
	import Omelet from './views/Omelet.svelte';
	import Regular from './views/Regular.svelte';
	import About from './views/About.svelte';
	import Inspire from './views/Inspiration.svelte';



	function toggle() {
		user.Hide = !user.Hide;
	}
</script>
<nav>
	<a href="/#/">Home</a> |
	<a href="/#/omelet">Omelet Egg Type</a> |
	<a href="/#/regular">Fried Egg Type </a> |
	<a href="/#/about">About</a> |
	<a href="/#/inspire">Inspiration</a> 
	
</nav>




<Router routes={{
	'/': Home,
	'/omelet': Omelet,
	'/regular': Regular,
	'/about': About,
	'/inspire': Inspire
}} />
<hr>
<!-- /#{$location} -->